import { useEffect } from 'react';

import {
  type ScanSessionFlags,
  createScanSessionStore,
  currentUtcMonth,
  scanSessionFlagsFor,
} from '@splitfiesta/core';

import { useAuthStore } from '@/stores/authStore';

/** Receipt-scan flags for this page session; a reload asks the server again. */
export const useScanSession = createScanSessionStore();

const CLEARED: ScanSessionFlags = {
  proNotAvailableSeen: false,
  fairUseHit: false,
};

/**
 * The flags for the signed-in user in the current UTC month. Flags set for
 * another account or a past month read as cleared on this render, and the
 * effect then resets the store, so no sign-out path needs to remember it.
 */
export function useScanSessionFlags(): ScanSessionFlags {
  const userId = useAuthStore(state => state.user?.id ?? null);
  const nowMonth = currentUtcMonth();
  const boundUser = useScanSession(state => state.userId);
  const proNotAvailableSeen = useScanSession(
    state => scanSessionFlagsFor(state, nowMonth).proNotAvailableSeen
  );
  const fairUseHit = useScanSession(
    state => scanSessionFlagsFor(state, nowMonth).fairUseHit
  );

  useEffect(() => {
    useScanSession.getState().bindToUser(userId, nowMonth);
  }, [userId, nowMonth]);

  if (boundUser !== userId) return CLEARED;
  return { proNotAvailableSeen, fairUseHit };
}
